import { render } from "./AwMenu.vue?vue&type=template&id=04fb2375"
import script from "./AwMenu.vue?vue&type=script&lang=js"
export * from "./AwMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__